var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransmitir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 83,
    viewBox: "0 0 81 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2206 83V43H3.14267C2.91706 43.0002 2.69646 42.9335 2.50871 42.8082C2.32095 42.683 2.17447 42.505 2.08774 42.2965C2.00101 42.088 1.97792 41.8585 2.0214 41.6369C2.06488 41.4153 2.17296 41.2116 2.33202 41.0514L40.3471 3L78.3622 41.0514C78.5213 41.2116 78.6293 41.4153 78.6728 41.6369C78.7163 41.8585 78.6932 42.088 78.6065 42.2965C78.5198 42.505 78.3733 42.683 78.1855 42.8082C77.9978 42.9335 77.7772 43.0002 77.5515 43H57.4736V83",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransmitir);
export default __webpack_public_path__ + "static/media/icon_transmitir.00bf0350a4a4733be58c3ca81329aa83.svg";
export { ForwardRef as ReactComponent };